import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTencentweiboComponent } from './simple-icons-tencentweibo.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTencentweiboComponent ],
    exports:      [ SimpleIconsTencentweiboComponent ],
    bootstrap:    []
})
export class SimpleIconsTencentweiboModule {}
